module.exports = {"meta":{"description":"Users in the variant bucket can comment, react, or edit team-visible boards with \"Allow Team Members to Join\" enabled without explicitly clicking \"Join Board\".","link":"https://trello.com/c/4VuXrUI4/294-make-it-easier-for-team-members-to-start-contributing-to-boards"},"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0.2,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/teamBoardContribution.json
// module id = NqMj
// module chunks = 12